import { createRouter, RouterProvider } from "@tanstack/react-router";
// Import the generated route tree
import { routeTree } from "../routeTree.gen";
// Providers that need to be global
import { Providers } from "./providers"; // Assuming 'providers' resolves to providers.jsx

function App({ queryClient }) {
  // The router instance no longer needs synchronous auth state.
  // The __root route loader is now the single source of truth for auth data.
  const router = createRouter({
    routeTree,
    defaultPreload: "intent",
    // The initial context now only needs to contain dependencies like the queryClient.
    context: {
      queryClient,
      auth: undefined, // Or just omit it. Loader data will overwrite this.
    },
  });

  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}

export default App;
